import { FaStar, FaStarHalf } from "react-icons/fa"; // Importing star icon

const StarView = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating); // Get the integer part of the rating
    const hasHalfStar = rating % 1 >= 0.5; // Check if there's a half star
  
    // Add full stars
    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={`full-${i}`} color="#ffc107" size={16} />);
    }
  
    // Add half star if needed
    if (hasHalfStar) {
      stars.push(<FaStarHalf key="half" color="#ffc107" size={16} />);
    }
  
    // Add empty stars to fill up to 5
    const totalStars = 5;
    const remainingStars = totalStars - fullStars - (hasHalfStar ? 1 : 0);
    for (let i = 0; i < remainingStars; i++) {
      stars.push(<FaStar key={`empty-${i}`} color="#e4e5e9" size={16} />);
    }
  
    return <>{stars}</>; // Return the JSX fragment containing the stars
};

export default StarView;
